import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

export const LockedExternalSection = () => {
  const { values: { redirectConfigurationUrl } } = useFormContext()

  return (
    <>
      <BodyText>
        {I18n.t('publisher.event_types.confirmation_page.type.external')}
      </BodyText>
      <BodyText weight="bold">
        {I18n.t('publisher.event_types.confirmation_page.labels.redirect_url')}
      </BodyText>
      <BodyText>
        {redirectConfigurationUrl}
      </BodyText>
    </>
  )
}
